import { testosteroneHqCommonEnvironment } from '@environments/testosterone-hq/environment.common';
import { AppEnvironment } from '@models/app-environment';

/**
 * Environment variables for use on the Testosterone HQ site, in production environment.
 */
export const environment: AppEnvironment = {
  ...testosteroneHqCommonEnvironment,
  production: true,
  apiUrl: 'https://api.analytecare.com',
  analyteCareApi: 'https://api.analytecare.com',
  googleMapApiKey: 'AIzaSyDIEZHrvUCVq39wvL0mBOanghqkHIk8cRE',
  braintreeToken: 'production_csgfcd5t_53b8hvj83v98kzmr',
  googlePay: {
    merchantId: 'BCR2DN4TQ3K3DXR3',
    apiVersion: 2,
    apiVersionMinor: 0,
  },
  defaultOrderLabId: '27349',
  oncehubSchedulingUrl: 'https://go.oncehub.com',
  siteUrls: {
    home: 'https://www.testosteronehq.com',
    termsOfService: 'https://www.testosteronehq.com/terms/',
    myAccount: 'https://my-account.testosteronehq.com',
    tests: 'https://www.testosteronehq.com',
    notFound: 'https://www.testosteronehq.com/404',
  },
  ngFindalab: {
    ...testosteroneHqCommonEnvironment.ngFindalab,
    inHomeCollectionAllowed: false,
  },
};
